<div class="flex flex-col gap-1 hover:cursor-pointer">
  <div
    (click)="sortAction(false)"
    [class.selected-sort]="!descActive && !deselected"
    class="transform transition duration-100 hover:scale-110"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="size-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m4.5 15.75 7.5-7.5 7.5 7.5"
      />
    </svg>
  </div>
  <div
    (click)="sortAction(true)"
    [class.selected-sort]="descActive && !deselected"
    class="transform transition duration-100 hover:scale-110"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="size-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m19.5 8.25-7.5 7.5-7.5-7.5"
      />
    </svg>
  </div>
</div>
